<template>
  <div class="provinceLine">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>当前位置</el-breadcrumb-item>
        <el-breadcrumb-item>智能填报</el-breadcrumb-item>
        <el-breadcrumb-item>省控线</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <!-- <Score></Score> -->
      <!-- <div style="border-bottom: 1px solid #f4f4f4">
        <el-radio-group v-model="year" size="medium" @change="getData()" style="margin-left: 75px">
          <el-radio-button label="2024" />
          <el-radio-button label="2023" />
          <el-radio-button label="2022" />
          <el-radio-button label="2021" />
          <el-radio-button label="2020" />
          <el-radio-button label="2019" />
          <el-radio-button label="2018" />
        </el-radio-group>
      </div> -->
      <div>
        <div v-loading="loading" style="padding: 20px 77px">
          <div>
            <p class="title_score">2026年普通高校招生录取控制分数线</p>
            <table class="table_score">
              <tr class="title_table">
                <td rowspan="2" class="font_2">类别</td>
                <td rowspan="2" colspan="2">录取批次</td>
                <td colspan="4">文化线分数（分）</td>
                <td rowspan="2" colspan="3">专业分数线</td>
              </tr>
              <tr class="title_table">
                <td colspan="2">历史类</td>
                <td colspan="2">物理类</td>
              </tr>
              <tr>
                <td rowspan="4" class="font_3">普通类</td>
                <td colspan="2">特殊类型</td>
                <td colspan="2">{{ 534 }}</td>
                <td colspan="2">{{ 513 }}</td>
                <td colspan="3">--</td>
              </tr>
              <tr>
                <td colspan="2">普通本科批</td>
                <td colspan="2">459</td>
                <td colspan="2">419</td>
                <td colspan="3">--</td>
              </tr>
              <tr>
                <td colspan="2">普通高职(专科)批</td>
                <td colspan="2">179</td>
                <td colspan="2">179</td>
                <td colspan="3">--</td>
              </tr>
              <tr>
                <!-- <td colspan="9">
                  备注：国家专项批和地方专项批执行本科一批分数线，专科提前批执行高职高专批分数线
                </td> -->
              </tr>
              <tr>
                <td rowspan="2" class="font_3">体育类</td>
                <td colspan="2">体育本科批</td>
                <td colspan="2">368</td>
                <td colspan="2">356</td>
                <td colspan="3">108</td>
              </tr>
              <tr>
                <td colspan="2">体育高职(专科)批</td>
                <td colspan="2">179</td>
                <td colspan="2">179</td>
                <td colspan="3">92</td>
              </tr>
              <tr class="font_3">
                <td rowspan="12">艺术类</td>
                <td rowspan="2" colspan="2">专业考试类别</td>
                <td colspan="2">本科</td>
                <td colspan="2">高职(专科)</td>
                <td rowspan="2" colspan="2">本科</td>
                <td rowspan="2" colspan="2"> 高职(专科)</td>
              </tr>
              <tr>
                <td>历史类</td>
                <td>物理类</td>
                <td>历史类</td>
                <td>物理类</td>
              </tr>
              <tr>
                <td rowspan="3">音乐类</td>
                <td>音乐表演(声乐)</td>
                <td>327</td>
                <td>366</td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">230</td>
                <td colspan="2">195</td>
              </tr>
              <tr>
                <td>音乐表演(器乐)</td>
                <td>334</td>
                <td>
                  359
                </td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">230</td>
                <td colspan="2">195</td>
              </tr>
              <tr>
                <td>音乐教育</td>
                <td>349</td>
                <td>
                  373
                </td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">208</td>
                <td colspan="2">198</td>
              </tr>
              <tr>
                <td colspan="2">舞蹈类</td>
                <td>302</td>
                <td>
                  290
                </td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">219</td>
                <td colspan="2">203</td>
              </tr>
              <tr>
                <td rowspan="3">表（导）演类</td>
                <td>戏剧影视表演方向</td>
                <td>355</td>
                <td>
                  396
                </td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">237</td>
                <td colspan="2">207</td>
              </tr>
              <tr>
                <td>服装表演方向</td>
                <td>347</td>
                <td>
                  366
                </td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">208</td>
                <td colspan="2">187</td>
              </tr>
              <tr>
                <td>戏剧影视导演方向</td>
                <td>348</td>
                <td>
                  388
                </td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">225</td>
                <td colspan="2">210</td>
              </tr>
              <tr>
                <td colspan="2">播音与主持类</td>
                <td>367</td>
                <td>
                  384
                </td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">212</td>
                <td colspan="2">200</td>
              </tr>
              <tr>
                <td colspan="2">美术与设计类</td>
                <td>323</td>
                <td>
                  332
                </td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">189</td>
                <td colspan="2">175</td>
              </tr>
              <tr>
                <td colspan="2">书法类</td>
                <td>357</td>
                <td>
                  330
                </td>
                <td>159</td>
                <td>159</td>
                <td colspan="2">206</td>
                <td colspan="2">182</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Score from "./components/Score";
export default {
  name: "ProvinceLine",
  components: {
    // Score,
  },
  data() {
    return {
      list: [],
      year: 2026,
      loading: false,
      test: false
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.breadcrumb {
  width: 1100px;
  margin: 0 auto;
}

.provinceLine {
  background: #f4f4f4;

  .content {
    width: 1100px;
    background: #fff;
    padding: 30px 0;
    margin: 0 auto;
  }

  .title_score {
    color: #464645;
    font-size: 20px;
    margin: 20px 0;
    padding: 0 20px;
    text-align: center;
  }

  .table_score {
    width: 100%;

    .title_table {
      td {
        background: #1498ea !important;
        color: #ffffff;
      }
    }

    td {
      text-align: center;
      border-collapse: collapse;
      background: #f4f4f4;
      border: 1px solid white;
      padding: 10px 7px;
    }

    .font_1 {
      width: 90px;
    }

    .font_2 {
      width: 30px;
    }

    .font_3 {
      font-weight: bold !important;
    }
  }

  .table_score1 {
    width: 100%;
    border-collapse: collapse;

    .title_table {
      td {
        background: #1498ea !important;
        color: #ffffff;
      }
    }

    td {
      text-align: center;
      width: 50px;
      background: #f4f4f4;
      border: 5px solid white;
      padding: 10px 7px;
    }

    .font_11 {
      width: 90px;
    }

    .font_21 {
      width: 30px;
    }

    .font_31 {
      font-weight: bold !important;
    }
  }
}
</style>